import type { EventNodeContext } from "@tsmono/inspect-components/transcript";
import type { SearchReferenceLabels } from "@tsmono/inspect-components/transcript-search";

/**
 * Folds search-derived cite labels into an existing transcript event context
 * (e.g. the scanner-cite context). Message labels from both sources combine,
 * with search labels winning on id conflicts; event labels come from search.
 * Returns undefined only when neither source contributes anything.
 */
export const mergeTranscriptLabelContext = (
  base: Partial<EventNodeContext> | undefined,
  searchLabels: SearchReferenceLabels | undefined
): Partial<EventNodeContext> | undefined => {
  const messageLabels = {
    ...base?.messageLabels,
    ...searchLabels?.messageLabels,
  };
  const eventLabels = {
    ...base?.eventLabels,
    ...searchLabels?.eventLabels,
  };

  const hasMessageLabels = Object.keys(messageLabels).length > 0;
  const hasEventLabels = Object.keys(eventLabels).length > 0;
  if (!base && !hasMessageLabels && !hasEventLabels) return undefined;

  return {
    ...base,
    ...(hasMessageLabels ? { messageLabels } : {}),
    ...(hasEventLabels ? { eventLabels } : {}),
  };
};
